

















import { Component, Vue, Prop } from 'vue-property-decorator';
import PersonData from '@/ts/PersonData';

@Component
export default class Avatar extends Vue {
    @Prop() public personId: number;
    @Prop() public className: string;

    constructor() {
        super();
    }

    get person(): PersonData {
        return this.$store.getters['User/getCacheUser'](this.personId);
    }

    get senderImage() {
        if (this.person.fetchedMiniature === false) {
            this.person.fetchMiniature(this.$store);
            this.person.fetchedMiniature = true;
        }

        if (typeof this.person !== 'undefined') {
            if (this.person.hasMiniature || this.person.hasProfileImage) {

                if (this.person.hasMiniature) {
                    return this.person.miniatureImage;
                }

                if (this.person.hasProfileImage) {
                    return this.person.profileImage;
                }
            }
        }

        return null;
    }
}
